const t = (...s) => s.filter(([, e = !0]) => e).map(([e]) => e).join(" ");
export {
  t as classnames
};
//# sourceMappingURL=classnames.js.map
